import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import Countdown from 'react-countdown';
import ReactBSAlert from "react-bootstrap-sweetalert";
import WizardStorage from "./components/WizardStorage";
import rustItems from "../variables/items";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Button,
  CustomInput,
  UncontrolledTooltip
} from "reactstrap";

import { storageConfirmEdit, storageEnterEditMode, storageCancelEditMode, storageDelete, storagePreEdit } from '../redux/actions/storages.action';
import { editDeviceName, closeModal } from '../redux/actions/modal.devices.action';

const deviceName = /^[\p{L} \-\d]{0,24}$/u;
const Storages = (props) => {
    const { t } = useTranslation(['devices', 'common', 'storage']);
    const [alert, setAlert] = React.useState(null);
    const [modalDeviceName, setmodalDeviceName] = useState('');
    const handleChangeDeviceName = (e) => {
        if (deviceName.test(e.target.value)) setmodalDeviceName(e.target.value);
    }
    const confirmDeviceName = () => {
        if (modalDeviceName.length < 1) return;
        props.editDeviceName(modalDeviceName);
        setmodalDeviceName("");
    }
    const getItemImg = (id) => {
        if (!id) return false;
        const item = rustItems.find((i) => i.id === id.toString());
        if (!item) return false;
        return `https://rustlink.io/api/image/${item.short}/32`;
    }
    const deleteConfirmation = (id) => {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t('common:confirmUnlist')}
          onConfirm={() => successRemove(id)}
          onCancel={() => cancelRemove()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t('common:confirmYes')}
          cancelBtnText={t('common:cancel')}
          showCancel
          btnSize=""
        >
        </ReactBSAlert>
      );
    };
    
    const successRemove = (id) => {
      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title={t('common:removed')}
          onConfirm={() => hideAlert(id)}
          onCancel={() => hideAlert(false)}
          confirmBtnBsStyle="success"
          btnSize=""
        >
          {t('deviceUnlisted')}
        </ReactBSAlert>
      );
    };
    const cancelRemove = () => {
      setAlert(
        <ReactBSAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title={t('common:cancelled')}
          onConfirm={() => hideAlert(false)}
          onCancel={() => hideAlert(false)}
          confirmBtnBsStyle="success"
          btnSize=""
        >
        </ReactBSAlert>
      );
    };
    
    const hideAlert = (id = false) => {
      setAlert(null);
      if (id) {
        props.storageDelete(id);
      }
    };
    const getTCs = () => {
        if (!props.storages.length) return false;
        let tcsIds = props.storages.map((storage, i) => {return(storage.isTC === true ? i : '')}).filter(String);
        if (!tcsIds.length) return false;
        else {
            tcsIds.map(id => {
                return props.storages[id].info = getTcInfo(id);
            });
            return tcsIds;
        }
    }

    const getStorages = () => {
        if (!props.storages.length) return false;
        let storagesIds = props.storages.map((storage, i) => {return(storage.isStorage === true ? i : '')}).filter(String);
        if (!storagesIds.length) return false;
        else return storagesIds;
    }
    const getVendings = () => {
        if (!props.storages.length) return false;
        let storagesIds = props.storages.map((storage, i) => {return(storage.isVending === true ? i : '')}).filter(String);
        if (!storagesIds.length) return false;
        else return storagesIds;
    }

    const ressourcesId = {
        wood: -151838493,
        stone: -2099697608,
        metal: 69511070,
        hq: 317398316
    };
    const getTcInfo = (id) => {
        if (!props.storages) return false;
        if (!props.storages[id]) return false;
        var info = {
            wood: 0,
            stone: 0,
            metal: 0,
            hq: 0
        };
        let woodsIds = props.storages[id].items.map((ressource, i) => (ressource.itemId === ressourcesId['wood'] ? i : '')).filter(String);
        woodsIds && woodsIds.map(wId => {
            return info.wood += props.storages[id].items[wId].quantity;
        });
        let stoneIds = props.storages[id].items.map((ressource, i) => (ressource.itemId === ressourcesId['stone'] ? i : '')).filter(String);
        stoneIds && stoneIds.map(wId => {
            return info.stone += props.storages[id].items[wId].quantity;
        });
        let metalIds = props.storages[id].items.map((ressource, i) => (ressource.itemId === ressourcesId['metal'] ? i : '')).filter(String);
        metalIds && metalIds.map(wId => {
            return info.metal += props.storages[id].items[wId].quantity;
        });
        let hqIds = props.storages[id].items.map((ressource, i) => (ressource.itemId === ressourcesId['hq'] ? i : '')).filter(String);
        hqIds && hqIds.map(wId => {
            return info.hq += props.storages[id].items[wId].quantity;
        });
        return info;
    }
    const formatZero = (value, zone) => {
        if (value > 9) return `${value}${zone}`;
        else return `0${value}${zone}`;
    };
    const renderRemainingTime = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          return <span className="c-red">Decaying</span>;
        } else {
          return <span>{`${formatZero(days,'d')} ${formatZero(hours, 'h')} ${formatZero(minutes, 'm')} ${formatZero(seconds, 's')}`}</span>;
        }
    };
    return (
        <>
            {alert}
            <div className="content">
                <Modal className="modalNewDevice" isOpen={props.modal && props.modal.display && props.modal.type === "storage"} animation={false} fade={false}>
                    <div className="modal-header justify-content-center">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                    >
                        <i className="tim-icons icon-simple-remove" onClick={() => props.closeModal()}/>
                    </button>
                    <h6 className="title title-up">{t(`modal.${props.modal.title}`)}</h6>
                    </div>
                    <ModalBody className="text-center">
                    <p>{t(`modal.${props.modal.description}`)}</p>
                    <Input style={ {color: '#1e1e2f'} } placeholder={t('common:name')} value={modalDeviceName} onChange={handleChangeDeviceName} type="text" />
                    </ModalBody>
                    <div className="modal-footer">
                    <Button
                        disabled={modalDeviceName.length < 1}
                        color="default"
                        type="button"
                        onClick={() => confirmDeviceName()}
                    >
                        {t('common:confirm')}
                    </Button>
                    </div>
                </Modal>
                <div className="storageContent">
                    {getTCs() &&
                        <>
                            <div className="storageTitle">{t('storage:toolcup')}</div>
                            <div className="storageBody">
                                <Row className="storage">
                                    {getTCs().map(id => {return(<Col xl="4" lg="6" md="6" xs="12">
                                        <Card className="cardStorage">
                                            <CardBody className="storage_body">
                                                {props.storages[id] && props.storages[id].isEdited  ? 
                                                    (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-check-2" onClick={() => props.storageCancelEditMode(props.storages[id].id)}/></div>)
                                                    : (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-settings-gear-63" onClick={() => props.storageEnterEditMode(props.storages[id].id)}/><i className="storage_btns_icons tim-icons icon-simple-remove" onClick={() => deleteConfirmation(props.storages[id].id)}/></div>)}
                                                <Row className="h-100" onClick={() => !props.storages[id].isEdited && props.storageEnterEditMode(props.storages[id].id)}>
                                                    <Col xs="6">
                                                        <div className="name">{t('common:name')}</div>
                                                        {props.storages[id] && props.storages[id].isEdited ?
                                                            <FormGroup>
                                                            <Input placeholder={t('common:name')} type="text" value={props.storages[id]?.edit?.name || ''} onChange={(e) => props.storagePreEdit(props.storages[id].id, 'name', e.target.value)} onBlur={() => props.storageConfirmEdit(props.storages[id].id, props.storages[id]?.edit.name || '', props.storages[id]?.edit.isCalculator || false)}/>
                                                        </FormGroup> :
                                                        <div className="title">{props.storages[id]?.name || t('common:notSetup')}</div>}
                                                    </Col>
                                                    <Col xs="6">
                                                        <div className="upkeepTitle">{t('storage:upkeep')}</div>
                                                        <div className="upkeepValue">
                                                            <Countdown
                                                                date={(new Date().getTime() + props.storages[id].remainingTime * 1000)}
                                                                renderer={renderRemainingTime}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="toolContent" onClick={() => props.storageEnterEditMode(props.storages[id].id)}>
                                                    <Row>
                                                        <Col xs="3" className="toolContentRessource">
                                                            <div className="toolContentRessourceBackground">
                                                                <img className="toolContentImg" alt="toolContentImg" src="https://i.gyazo.com/20849c0e3d103af66e5f1fab61703702.png" />
                                                                <div className={`toolContentImgValue ${props.storages[id].isDecaying && props.storages[id].missingRessource === ressourcesId['wood'] ? 'c-red' : 'c-white'}`}>{props.storages[id].info.wood}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs="3" className="toolContentRessource">
                                                            <div className="toolContentRessourceBackground">
                                                                <img className="toolContentImg" alt="toolContentImg" src="https://i.gyazo.com/78dc68ad2c8824681eb91787e7deb00a.png" />
                                                                <div className={`toolContentImgValue ${props.storages[id].isDecaying && props.storages[id].missingRessource === ressourcesId['stone'] ? 'c-red' : 'c-white'}`}>{props.storages[id].info.stone}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs="3" className="toolContentRessource">
                                                            <div className="toolContentRessourceBackground">
                                                                <img className="toolContentImg" alt="toolContentImg" src="https://i.gyazo.com/4c50a10d2f95122be201a5c94a463712.png" />
                                                                <div className={`toolContentImgValue ${props.storages[id].isDecaying && props.storages[id].missingRessource === ressourcesId['metal'] ? 'c-red' : 'c-white'}`}>{props.storages[id].info.metal}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs="3" className="toolContentRessource">
                                                            <div className="toolContentRessourceBackground">
                                                                <img className="toolContentImg" alt="toolContentImg" src="https://i.gyazo.com/55bdd08f99d0da711f6a2f272ff8ca3e.png" />
                                                                <div className={`toolContentImgValue ${props.storages[id].isDecaying && props.storages[id].missingRessource === ressourcesId['hq'] ? 'c-red' : 'c-white'}`}>{props.storages[id].info.hq}</div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>)})}
                                </Row>
                            </div>
                        </>
                    }
                    {getStorages() && 
                    <>
                        <div className="storageTitle">{t('storage:storages')}</div>
                        <div className="storageBody">
                            <Row className="storage">
                                {getStorages().map(id => {return(<Col xl="4" lg="6" md="6" xs="12">
                                    <Card className="cardStorage">
                                        <CardBody className="storage_body">
                                            {props.storages[id] && props.storages[id].isEdited  ? 
                                                    (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-check-2" onClick={() => props.storageCancelEditMode(props.storages[id].id)}/></div>)
                                                    : (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-settings-gear-63" onClick={() => props.storageEnterEditMode(props.storages[id].id)}/><i className="storage_btns_icons tim-icons icon-simple-remove" onClick={() => deleteConfirmation(props.storages[id].id)}/></div>)}
                                            {props.storages[id] && props.storages[id].isEdited ?
                                                (
                                                <Row>
                                                    <Col xs="6">
                                                        <div className="name">{t('common:name')}</div>
                                                        <FormGroup>
                                                            <Input placeholder={t('common:name')} type="text" value={props.storages[id]?.edit?.name} onChange={(e) => props.storagePreEdit(props.storages[id].id, 'name', e.target.value)} onBlur={() => props.storageConfirmEdit(props.storages[id].id, props.storages[id].edit.name, props.storages[id].edit.isCalculator)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs="6" id="scrapCalculator">
                                                        <div className="name">{t('common:scrapCalculator')}</div>
                                                        <CustomInput
                                                            type="switch"
                                                            id={`switch-${props.storages[id].id}-scrap`}
                                                            checked={props.storages[id].edit.isCalculator}
                                                            onChange={(e) => props.storagePreEdit(props.storages[id].id, 'isCalculator', e.target.checked)}
                                                            className="sw_checkbox"
                                                        />
                                                    </Col>
                                                    {props.vip.plan < 3 && <UncontrolledTooltip delay={2} placement="right" target="scrapCalculator">{t('common:featureNotAvailable')}</UncontrolledTooltip>}
                                                </Row>
                                                ) :
                                            (
                                            <Row onClick={() => props.storageEnterEditMode(props.storages[id].id)}>
                                                <Col xs="6">
                                                    <div className="name">{t('common:name')}</div>
                                                    <div className="title">
                                                        {props.storages[id]?.name || t('common:notSetup')}
                                                    </div>
                                                </Col>
                                                {props.storages[id].isCalculator && <Col xs="6">
                                                    <div className="name">{t('common:scrapCalculator')}</div>
                                                    <div className="title">
                                                        ON
                                                    </div>
                                                </Col>}
                                            </Row>
                                            )}
                                            <div className="storage_content" onClick={() => !props.storages[id].isEdited && props.storageEnterEditMode(props.storages[id].id)}>
                                                <div className="storage_content_title">
                                                    {t('storage:content')}
                                                </div>
                                                <Row className="storage_content_items">
                                                    {/*<Col xs="2" className="storage_content_item">
                                                        <img className="storage_content_item_img" alt="storage_content_item_img" src="https://i.gyazo.com/55bdd08f99d0da711f6a2f272ff8ca3e.png" />
                                                        <div className="storage_content_item_value">x1000</div>
                                                    </Col>*/}
                                                    {
                                                        [...Array(props.storages[id].isVending ? 30 : 48)].map((x, iId) => {
                                                            return(<Col xs="2" className="storage_content_item">
                                                                {props.storages[id].items[iId] ? (<img className="storage_content_item_img" alt="storage_content_item_img" src={getItemImg(props.storages[id].items[iId].itemId)} />) : (<></>)}
                                                                {props.storages[id].items[iId] ? (<div className="storage_content_item_value">{`x${props.storages[id].items[iId].quantity}`}</div>) : (<></>)}
                                                            </Col>)
                                                        })
                                                    }
                                                </Row>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>)})}
                            </Row>
                        </div>
                    </>}

                    {getVendings() && 
                    <>
                        <div className="storageTitle">{t('storage:vendings')}</div>
                        <div className="storageBody">
                            <Row className="storage">
                                {getVendings().map(id => {return(<Col xl="4" lg="6" md="6" xs="12">
                                    <Card className="cardStorage">
                                        <CardBody className="storage_body">
                                            {props.storages[id] && props.storages[id].isEdited  ? 
                                                    (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-check-2" onClick={() => props.storageCancelEditMode(props.storages[id].id)}/></div>)
                                                    : (<div className="storage_btns"><i className="storage_btns_icons tim-icons icon-settings-gear-63" onClick={() => props.storageEnterEditMode(props.storages[id].id)}/><i className="storage_btns_icons tim-icons icon-simple-remove" onClick={() => deleteConfirmation(props.storages[id].id)}/></div>)}
                                            {props.storages[id] && props.storages[id].isEdited ?
                                                (
                                                <Row>
                                                    <Col xs="6">
                                                        <div className="name">{t('common:name')}</div>
                                                        <FormGroup>
                                                            <Input placeholder={t('common:name')} type="text" value={props.storages[id]?.edit?.name} onChange={(e) => props.storagePreEdit(props.storages[id].id, 'name', e.target.value)} onBlur={() => props.storageConfirmEdit(props.storages[id].id, props.storages[id].edit.name, props.storages[id].edit.isCalculator)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs="6" id="scrapCalculator">
                                                        <div className="name">{t('common:scrapCalculator')}</div>
                                                        <CustomInput
                                                            type="switch"
                                                            id={`switch-${props.storages[id].id}-scrap`}
                                                            checked={props.storages[id].edit.isCalculator}
                                                            onChange={(e) => props.storagePreEdit(props.storages[id].id, 'isCalculator', e.target.checked)}
                                                            className="sw_checkbox"
                                                        />
                                                    </Col>
                                                    {props.vip.plan < 3 && <UncontrolledTooltip delay={2} placement="right" target="scrapCalculator">{t('common:featureNotAvailable')}</UncontrolledTooltip>}
                                                </Row>
                                                ) :
                                            (
                                            <Row onClick={() => props.storageEnterEditMode(props.storages[id].id)}>
                                                <Col xs="6">
                                                    <div className="name">{t('common:name')}</div>
                                                    <div className="title">
                                                        {props.storages[id]?.name || t('common:notSetup')}
                                                    </div>
                                                </Col>
                                                {props.storages[id].isCalculator && <Col xs="6">
                                                    <div className="name">{t('common:scrapCalculator')}</div>
                                                    <div className="title">
                                                        ON
                                                    </div>
                                                </Col>}
                                            </Row>
                                            )}
                                            <div className="storage_content" onClick={() => !props.storages[id].isEdited && props.storageEnterEditMode(props.storages[id].id)}>
                                                <div className="storage_content_title">
                                                    {t('storage:content')}
                                                </div>
                                                <Row className="storage_content_items">
                                                    {/*<Col xs="2" className="storage_content_item">
                                                        <img className="storage_content_item_img" alt="storage_content_item_img" src="https://i.gyazo.com/55bdd08f99d0da711f6a2f272ff8ca3e.png" />
                                                        <div className="storage_content_item_value">x1000</div>
                                                    </Col>*/}
                                                    {
                                                        [...Array(props.storages[id].isVending ? 30 : 48)].map((x, iId) => {
                                                            return(<Col xs="2" className="storage_content_item">
                                                                {props.storages[id].items[iId] ? (<img className="storage_content_item_img" alt="storage_content_item_img" src={getItemImg(props.storages[id].items[iId].itemId)} />) : (<></>)}
                                                                {props.storages[id].items[iId] ? (<div className="storage_content_item_value">{`x${props.storages[id].items[iId].quantity}`}</div>) : (<></>)}
                                                            </Col>)
                                                        })
                                                    }
                                                </Row>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>)})}
                            </Row>
                        </div>
                    </>}
                    {!props.storages.length && <WizardStorage/>}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { storages, modal } = state.devices;
    const { staff, vip } = state.infos;
    return { storages, staff, modal, vip };
};

const mapDispatchToProps = {
    storageConfirmEdit,
    storageDelete,
    storageCancelEditMode,
    storageEnterEditMode,
    storagePreEdit,
    editDeviceName,
    closeModal
};
export default connect(mapStateToProps, mapDispatchToProps)(Storages);